module.exports = __webpack_public_path__ + "fddeca88f18fa02cfabfaecfe8bad62d.pdf";